import {combineReducers} from 'redux'
import types from 'actions/types'

export const hubspotStatus = (state = null, action) => {
  switch (action.type) {
    case types.HUBSPOT_ENABLED_SUCCESS:
      return action.data
    case types.HUBSPOT_DISABLE_SUCCESS:
      return action.data
    case types.HUBSPOT_STATUS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const isUpdating = (state = false, action) => {
  switch (action.type) {
    case types.HUBSPOT_UPDATE_DATA_ATTEMPT:
      return true
    case types.HUBSPOT_UPDATE_DATA_SUCCESS:
      return false
    case types.HUBSPOT_UPDATE_DATA_FAILURE:
      return false
    default:
      return state
  }
}

export const lists = (state = [], action) => {
  switch (action.type) {
    case types.HUBSPOT_LOAD_LISTS_ATTEMPT:
      return []
    case types.HUBSPOT_LOAD_LISTS_SUCCESS:
      return action.data
    case types.HUBSPOT_LOAD_LISTS_FAILURE:
      return []
    default:
      return state
  }
}

export const mergeFields = (state = [], action) => {
  switch (action.type) {
    case types.HUBSPOT_LOAD_CONTACT_PROPERTIES_ATTEMPT:
      return []
    case types.HUBSPOT_LOAD_CONTACT_PROPERTIES_SUCCESS:
      return action.data
    case types.HUBSPOT_LOAD_CONTACT_PROPERTIES_FAILURE:
      return []
    default:
      return state
  }
}

export default combineReducers({
  hubspotStatus,
  isUpdating,
  lists,
  mergeFields,
})
